"use strict";
var __importDefault =
  (this && this.__importDefault) ||
  function(mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const BasicNode_1 = require("./BasicNode");
const utils_1 = require("../helper/utils");
const fetchOutputKeys_1 = require("../helper/fetchOutputKeys");
const AzureMonitoringNodeValidation_1 = require("../validations/AzureMonitoringNodeValidation");
const cloudProvider_1 = __importDefault(require("../types/cloudProvider"));
class AzureMonitoringNode extends BasicNode_1.BasicNode {
  constructor(props) {
    if (!props) props = { type: types_1.NODE_TYPES.Azure_Monitoring };
    if (props.type !== types_1.NODE_TYPES.Azure_Monitoring)
      throw new Error("Invalid Node type");
    super(props);
  }
  deserialize(data) {
    let nodeData = data || this.getNodeData();
    if (!nodeData)
      nodeData = {
        timespan: {
          startTime: "",
          endTime: ""
        },
        interval: "",
        metricnames: "Percentage CPU",
        aggregation: "Average"
      };
    return nodeData;
  }
  serialize(uiData) {
    return {
      ...uiData
    };
  }
  validate() {
    return new AzureMonitoringNodeValidation_1.AzureMonitoringNodeValidation().validate(
      this
    );
  }
  async getAvailableResourcesForAllPaths() {
    let availableResources = [];
    const selectedResource = this.getSelectedResource();
    if (!selectedResource || !selectedResource.nodeRef) return [];
    let options = await selectedResource.nodeRef.getAvailableResources();
    options = options.filter(x =>
      utils_1.selectedResourceNotEquals(x, selectedResource)
    );
    for (let option of options) {
      let postFix = option.label.substring(option.label.indexOf(".") + 1);
      let label = [this.getNodeName(), postFix].join(".");
      availableResources.push({
        nodeRef: this,
        selectedResourceId: this.id,
        path: option.path,
        label,
        context: option.context
      });
    }
    return availableResources;
  }
  async getAvailableResources() {
    let selectedResource = this.getSelectedResource();
    let availableResources = [];
    if (!selectedResource) return availableResources;
    if (selectedResource.label === "NONE") {
      return [
        {
          label: [this.getNodeName(), "metrics"].join("."),
          nodeRef: this,
          selectedResourceId: this.id,
          path: "",
          context: {
            outputPath: ""
          }
        }
      ];
    }
    const label = [
      this.getNodeName(),
      selectedResource.label.substr(selectedResource.label.lastIndexOf("."))
    ].join(".");
    if (!selectedResource.path) {
      let avRes = await this.getAvailableResourcesForAllPaths();
      availableResources = availableResources.concat(avRes);
    }
    availableResources.push({
      nodeRef: this,
      selectedResourceId: this.id,
      path: "",
      label,
      context: {
        outputPath: ""
      }
    });
    let addOnLabel = [label, "addOns", "metrics"].join(".");
    availableResources.push({
      label: addOnLabel,
      nodeRef: this,
      selectedResourceId: this.id,
      path: ["addOns", "metrics", "data"].join("."),
      context: {
        outputPath: `addOns.metrics.data`
      }
    });
    return availableResources;
  }
  async getOutputKeys(params) {
    const azureMonitorKeys = await fetchOutputKeys_1.fetchAzureOutputKeys(
      this.getDataResolver(),
      "monitor",
      "metrics",
      "list"
    );
    let selectedResource = this.getSelectedResource();
    if (!selectedResource) return [];
    if (selectedResource.label === "NONE") {
      return azureMonitorKeys;
    }
    let nodeRef = selectedResource.nodeRef;
    if (!nodeRef) return [];
    let outputKeys = await nodeRef.getOutputKeys(params);
    let modified = azureMonitorKeys.map(({ name, value }) => {
      let fieldName = "metrics";
      return {
        name: `${fieldName}.${name}`,
        value: `addOns.${fieldName}.data..${value}`
      };
    });
    outputKeys = outputKeys.concat(modified);
    if (
      !params.resource ||
      !params.resource.context ||
      !params.resource.context.outputPath
    )
      return outputKeys;
    return this.getKeysForPath(params.resource.context.outputPath, outputKeys);
  }
  setId(props) {
    this.setBasicNodeId(props);
  }
  getCloudProvider() {
    return cloudProvider_1.default.AZURE;
  }
}
exports.AzureMonitoringNode = AzureMonitoringNode;
//# sourceMappingURL=AzureMonitoringNode.js.map
